import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { OrganizationSettingsDataComponent } from './components/organization-settings-data/organization-settings-data.component';
import { ApplicationContextService } from '../../core/services/application-context.service';
import { OrganizationSettingsRepresentativesTableComponent } from './components/organization-settings-representatives-table/organization-settings-representatives-table.component';
import { Button } from 'primeng/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-organization-settings',
  imports: [
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    OrganizationSettingsDataComponent,
    OrganizationSettingsRepresentativesTableComponent,
    Button,
  ],
  templateUrl: './organization-settings.component.html',
  styleUrl: './organization-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationSettingsComponent {
  readonly #router = inject(Router);

  protected readonly applicationContextService = inject(
    ApplicationContextService,
  );

  protected navigateToMainPage(): void {
    this.#router.navigate(['/']);
  }
}
